import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[app-dynamic-rows]'
})
export class DynamicRowsDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}


// WEBPACK FOOTER //
// ./src/app/forms/dynamic-rows.directive.ts